/**
 * @generated SignedSource<<d6c565047c12076a40739a8455a40598>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentModuleListFragment$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly prerequisites: {
        readonly totalCount: number;
      } | null;
      readonly releasedAt: string | null;
      readonly viewerHasCompleted: boolean;
      readonly " $fragmentSpreads": FragmentRefs<"ContentModuleListItemFragment">;
    };
  }>;
  readonly " $fragmentType": "ContentModuleListFragment";
};
export type ContentModuleListFragment$key = {
  readonly " $data"?: ContentModuleListFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentModuleListFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "contentLabelIds"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentModuleListFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentUsageNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentUsage",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ContentUsageNodeConnection",
              "kind": "LinkedField",
              "name": "prerequisites",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalCount",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerHasCompleted",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "releasedAt",
              "storageKey": null
            },
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "contentLabelIds",
                  "variableName": "contentLabelIds"
                }
              ],
              "kind": "FragmentSpread",
              "name": "ContentModuleListItemFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentUsageNodeConnection",
  "abstractKey": null
};

(node as any).hash = "fe5d4ebc4c090e307c9817209a87bacd";

export default node;
